"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HydraulicPipeDataApi = exports.HydraulicPipeDataApiFactory = exports.HydraulicPipeDataApiFp = exports.HydraulicPipeDataApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * HydraulicPipeDataApi - axios parameter creator
 * @export
 */
const HydraulicPipeDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes: (getItemDataByUniqueIDsRequestParameters_1, ...args_1) => __awaiter(this, [getItemDataByUniqueIDsRequestParameters_1, ...args_1], void 0, function* (getItemDataByUniqueIDsRequestParameters, options = {}) {
            const localVarPath = `/hydraulicitemdata/pipeLayoutDataByUniqueIDs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemDataByUniqueIDsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.HydraulicPipeDataApiAxiosParamCreator = HydraulicPipeDataApiAxiosParamCreator;
/**
 * HydraulicPipeDataApi - functional programming interface
 * @export
 */
const HydraulicPipeDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HydraulicPipeDataApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(getItemDataByUniqueIDsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(getItemDataByUniqueIDsRequestParameters, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['HydraulicPipeDataApi.hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.HydraulicPipeDataApiFp = HydraulicPipeDataApiFp;
/**
 * HydraulicPipeDataApi - factory interface
 * @export
 */
const HydraulicPipeDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HydraulicPipeDataApiFp)(configuration);
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {HydraulicPipeDataApiHydraulicitemDataEndpointGetHydraulicPipeLayoutTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(requestParameters = {}, options) {
            return localVarFp.hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(requestParameters.getItemDataByUniqueIDsRequestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.HydraulicPipeDataApiFactory = HydraulicPipeDataApiFactory;
/**
 * HydraulicPipeDataApi - object-oriented interface
 * @export
 * @class HydraulicPipeDataApi
 * @extends {BaseAPI}
 */
class HydraulicPipeDataApi extends base_1.BaseAPI {
    /**
     * Get hydraulic pipe layout data based on provided element unique ID\'s.
     * @param {HydraulicPipeDataApiHydraulicitemDataEndpointGetHydraulicPipeLayoutTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicPipeDataApi
     */
    hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(requestParameters = {}, options) {
        return (0, exports.HydraulicPipeDataApiFp)(this.configuration).hydraulicitemDataEndpointGetHydraulicPipeLayoutTypes(requestParameters.getItemDataByUniqueIDsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HydraulicPipeDataApi = HydraulicPipeDataApi;
//# sourceMappingURL=hydraulic-pipe-data-api.js.map